(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["castle-gate-hero"] && !Shopify.designMode) return;
  try {
    

(() => {
  const revealScenes = () => {
    const scenes = document.querySelectorAll('[data-home-story-scene]');
    if (!('IntersectionObserver' in window) || matchMedia('(prefers-reduced-motion: reduce)').matches) {
      scenes.forEach(scene => scene.classList.add('is-visible'));
      return;
    }
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      });
    }, { threshold: .2, rootMargin: '0px 0px -8% 0px' });
    scenes.forEach(scene => observer.observe(scene));
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', revealScenes, { once: true });
  else revealScenes();
  document.addEventListener('shopify:section:load', revealScenes);
})();

(() => {
  const initialise = () => document.querySelectorAll('[data-castle-parallax]').forEach(root => {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const story = root.querySelector('.castle-parallax-story');
    const stage = root.querySelector('.castle-parallax-stage');
    const cards = [...root.querySelectorAll('.castle-gate-department')];
    const reduced = matchMedia('(prefers-reduced-motion: reduce)');
    const controller = new AbortController();
    let frame = 0;
    const clamp = n => Math.max(0, Math.min(1, n));
    const update = () => {
      frame = 0;
      if (!root.isConnected) return;
      story.classList.toggle('is-animated', !reduced.matches);
      const top = Math.min(110, document.querySelector('#header-component')?.offsetHeight || 0);
      root.style.setProperty('--castle-hero-top', top + 'px');
      const rect = story.getBoundingClientRect();
      const travel = Math.max(1, story.offsetHeight - stage.offsetHeight);
      root.style.setProperty('--castle-scroll', reduced.matches ? 0 : clamp((top - rect.top) / travel));
      cards.forEach(card => {
        const r = card.getBoundingClientRect();
        if (r.bottom > 0 && r.top < innerHeight) card.style.setProperty('--card-depth', reduced.matches ? 0 : clamp((innerHeight - r.top) / (innerHeight + r.height)));
      });
    };
    const request = () => { if (!frame) frame = requestAnimationFrame(update); };
    const options = {passive: true, signal: controller.signal};
    window.addEventListener('scroll', request, options);
    document.querySelector('.page-wrapper')?.addEventListener('scroll', request, options);
    window.addEventListener('resize', request, options);
    reduced.addEventListener('change', request, {signal:controller.signal});
    document.addEventListener('shopify:section:unload', event => {
      if (event.target.contains(root)) {controller.abort(); cancelAnimationFrame(frame);}
    }, {signal:controller.signal});
    update();
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialise, {once:true});
  else initialise();
  document.addEventListener('shopify:section:load', initialise);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["castle-guides-hub"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('castle-guides-hub')) {
  customElements.define('castle-guides-hub', class extends HTMLElement {
    connectedCallback() {
      this.motionQuery = matchMedia('(prefers-reduced-motion: reduce)');
      this.motionChange = () => this.configureMotion();
      this.motionQuery.addEventListener('change', this.motionChange);
      this.configureMotion();
    }
    configureMotion() {
      this.stopMotion();
      if (this.motionQuery.matches) return;
      if ('IntersectionObserver' in window) {
        this.reveals = new IntersectionObserver(entries => entries.forEach(entry => {
          if (entry.isIntersecting) { entry.target.classList.remove('cgh-entering'); this.reveals.unobserve(entry.target); }
        }), { threshold: 0.08 });
        this.querySelectorAll('[data-reveal]').forEach(el => {
          if (el.getBoundingClientRect().top > innerHeight) { el.classList.add('cgh-entering'); this.reveals.observe(el); }
        });
      }
      this.layers = [...this.querySelectorAll('[data-depth]')];
      this.onScroll = () => {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => {
          this.frame = 0;
          this.layers.forEach(img => {
            const rect = img.parentElement.getBoundingClientRect();
            if (rect.bottom < 0 || rect.top > innerHeight) return;
            const offset = Math.max(-24, Math.min(24, (innerHeight / 2 - rect.top - rect.height / 2) * 0.045));
            img.style.setProperty('--cgh-depth', offset + 'px');
          });
        });
      };
      window.addEventListener('scroll', this.onScroll, { passive: true });
      window.addEventListener('resize', this.onScroll, { passive: true });
      this.onScroll();
    }
    stopMotion() {
      this.reveals?.disconnect();
      if (this.onScroll) { window.removeEventListener('scroll', this.onScroll); window.removeEventListener('resize', this.onScroll); }
      if (this.frame) cancelAnimationFrame(this.frame);
      this.frame = 0;
      this.querySelectorAll('.cgh-entering').forEach(el => el.classList.remove('cgh-entering'));
      this.querySelectorAll('[data-depth]').forEach(el => el.style.removeProperty('--cgh-depth'));
    }
    disconnectedCallback() { this.stopMotion(); this.motionQuery?.removeEventListener('change', this.motionChange); }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
